import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const FooterSection = styled.footer`
  background: #1a1a1a;
  color: white;
  padding: 60px 0 30px;
  position: relative;
  overflow: hidden;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterColumn = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
`;

const FooterLink = styled.a`
  color: #ccc;
  text-decoration: none;
  margin-bottom: 0.8rem;
  transition: color 0.3s ease;

  &:hover {
    color: #667eea;
  }
`;

const FooterText = styled.p`
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialIcon = styled(motion.a)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: background 0.3s ease;

  &:hover {
    background: #667eea;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #333;
  color: #666;
`;

const Footer = () => {
  return (
    <FooterSection>
      <FooterContainer>
        <FooterColumn
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <FooterTitle>PedLite</FooterTitle>
          <FooterText>
            Transformando la educación a través de la tecnología. Nuestra plataforma
            hace que el aprendizaje sea accesible, divertido y efectivo para todos.
          </FooterText>
          <SocialLinks>
            <SocialIcon
              href="#"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <i className="fab fa-facebook-f"></i>
            </SocialIcon>
            <SocialIcon
              href="#"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <i className="fab fa-twitter"></i>
            </SocialIcon>
            <SocialIcon
              href="#"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <i className="fab fa-instagram"></i>
            </SocialIcon>
          </SocialLinks>
        </FooterColumn>

        <FooterColumn
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <FooterTitle>Enlaces Rápidos</FooterTitle>
          <FooterLink href="#about">Sobre nosotros</FooterLink>
          <FooterLink href="#features">Características</FooterLink>
          <FooterLink href="#testimonials">Testimonios</FooterLink>
          <FooterLink href="#download">Descargar</FooterLink>
        </FooterColumn>

      </FooterContainer>

      <Copyright>
        <FooterText>
          © {new Date().getFullYear()} PedLite. Todos los derechos reservados.
        </FooterText>
      </Copyright>
    </FooterSection>
  );
};

export default Footer; 